import button from "@/app/plugins/tailwind/components/button";
import card from "@/app/plugins/tailwind/components/card";
import dropdown from "@/app/plugins/tailwind/components/dropdown";
import panel from "@/app/plugins/tailwind/components/panel";
import sidebar from "@/app/plugins/tailwind/components/sidebar";
import tabview from "@/app/plugins/tailwind/components/tabview";
import inputSwitch from "@/app/plugins/tailwind/components/inputSwitch";
import inputText from "@/app/plugins/tailwind/components/inputText";
import menu from "@/app/plugins/tailwind/components/menu";
import message from "@/app/plugins/tailwind/components/message";
import dataTable from "@/app/plugins/tailwind/components/dataTable";
import paginator from "@/app/plugins/tailwind/components/paginator";
import toolbar from "@/app/plugins/tailwind/components/toolbar";
import badge from "@/app/plugins/tailwind/components/badge";
import dialog from "@/app/plugins/tailwind/components/dialog";
import tooltip from "@/app/plugins/tailwind/components/tooltip";
import carousel from "@/app/plugins/tailwind/components/carousel";
import textArea from "@/app/plugins/tailwind/components/textArea";
import divider from "@/app/plugins/tailwind/components/divider";
import multiSelect from "@/app/plugins/tailwind/components/multiSelect";
import inputGroup from "@/app/plugins/tailwind/components/inputGroup";
import inputGroupAddon from "@/app/plugins/tailwind/components/inputGroupAddon";
import treeSelect from "@/app/plugins/tailwind/components/treeSelect";
import slider from "@/app/plugins/tailwind/components/slider";
import cascadeSelect from "@/app/plugins/tailwind/components/cascadeSelect";
import floatLabel from "@/app/plugins/tailwind/components/floatLabel";
import checkBox from "@/app/plugins/tailwind/components/checkBox";
import accordion from "@/app/plugins/tailwind/components/accordion";
import toast from "@/app/plugins/tailwind/components/toast";
import chip from "@/app/plugins/tailwind/components/chip";

export const tailwindTheme = {
  tabview,
  dropdown,
  panel,
  card,
  sidebar,
  button,
  inputSwitch,
  inputText,
  menu,
  message,
  dataTable,
  paginator,
  toolbar,
  badge,
  dialog,
  tooltip,
  carousel,
  textArea,
  divider,
  multiSelect,
  inputGroup,
  inputGroupAddon,
  treeSelect,
  slider,
  cascadeSelect,
  floatLabel,
  checkBox,
  accordion,
  toast,
  chip,
};
